import { useCallback } from 'react';
import { sendCrossTabMessage } from 'worker-connection-library/calling-cross-tab-utils/sendCrossTabMessage';
import { createBroadcastMessage } from 'calling-integration-cross-tab/messages/createBroadcastMessages';
import { OPEN_WIDGET } from 'calling-integration-cross-tab/types/BroadcastEvents';
import { useThirdPartyWidgetDetailsContext } from 'calling-remote-common/context/ThirdPartyWidgetDetailsContext';
import { useOpenThirdPartyWidgetEvent } from './useOpenThirdPartyWidgetEvent';
import { openCallingWindow } from '../utils/callingWindowUtils';
import { handleDialThirdParty } from '../utils/handleDialThirdParty';
import { useOpenCloseRemote } from './useOpenCloseRemote';
import { useSelectedProviderContext } from 'calling-remote-common/context/SelectedProviderContext';
import { useOpenWidgetDataContext } from 'calling-integration-sdk-support/viewport/contexts/OpenWidgetDataContext';
import { openManagePropertiesPage } from '../utils/openManagePropertiesPage';
export const sendDialNumberToCallingWindow = dialNumberDetails => {
  sendCrossTabMessage(createBroadcastMessage({
    type: OPEN_WIDGET,
    payload: {
      dialNumberDetails
    }
  }));
};

// Handle open widget event for remote + calling window config
export const useOpenWindowFromDialer = ({
  ownerId
}) => {
  const {
    selectedCallProviderData
  } = useSelectedProviderContext();
  const [context] = useThirdPartyWidgetDetailsContext();
  const {
    thirdPartyIsPopupOpen
  } = context;
  const {
    setHasThirdPartyOpened,
    openRemote,
    closeRemote
  } = useOpenCloseRemote();
  const {
    updateOpenWidgetDataForCallingWindow,
    updateOpenWidgetDataForRemote
  } = useOpenWidgetDataContext();
  const handleOpenCallingWindow = useCallback(payload => {
    if (payload !== null && payload !== void 0 && payload.addPhoneNumber && payload !== null && payload !== void 0 && payload.toSubject) {
      const {
        objectTypeId,
        objectId
      } = payload.toSubject;
      openManagePropertiesPage({
        objectTypeId,
        objectId
      });
      closeRemote();
      return;
    }
    setHasThirdPartyOpened(true);
    openRemote();
    if (!thirdPartyIsPopupOpen) {
      openCallingWindow();
      handleDialThirdParty({
        openWidgetEvent: payload,
        ownerId,
        dialNumberProcessors: [updateOpenWidgetDataForRemote, updateOpenWidgetDataForCallingWindow]
      });
    } else {
      handleDialThirdParty({
        openWidgetEvent: payload,
        ownerId,
        dialNumberProcessors: [updateOpenWidgetDataForRemote, sendDialNumberToCallingWindow]
      });
    }
  }, [setHasThirdPartyOpened, thirdPartyIsPopupOpen, ownerId, updateOpenWidgetDataForCallingWindow, updateOpenWidgetDataForRemote, openRemote, closeRemote]);
  useOpenThirdPartyWidgetEvent(selectedCallProviderData, handleOpenCallingWindow);
};